import { Component, Input, OnInit } from '@angular/core';
import {StudentShoppingCartService} from "../../../../services/student-shopping-cart.service";
import * as LessonsV3 from '../../../../model/v3/lessons';

@Component({
    selector: 'app-product-box',
    templateUrl: './product-box.component.html',
    styleUrls: ['./product-box.component.scss'],
    standalone: false
})
export class ProductBoxComponent implements OnInit {
  @Input()
  product: LessonsV3.ProductVariantPreview;
  @Input()
  desc: String = '';
  @Input()
  notAvailable: String = null;

  constructor(private shoppingCart: StudentShoppingCartService) {}

  addItem() {
    this.shoppingCart.addItem(this.product);
  }

  ngOnInit(): void {}

  getPricePerLesson() {
    if (!this.product) return null;
    const price = this.product?.price?.value ?? 0;
    let weeks = 0;
    if (this.product?.description)
      weeks = +this.product.description.split(" ")[0];
    else if (this.isPlanFlexible())
      weeks = +this.product.name.split(" ")[0];
    const currency = this.product?.price?.currency ?? '';
    if (!weeks) {
      return null;
    }
    return `${(price / weeks).toFixed(2)} ${currency}`;
  }

  isPlanFlexible() {
    return this.product?.code?.includes("pag");
  }

  isEnbus() {
    return this.product?.product?.code?.includes("en.bs");
  }

  getProductType() {
    let type = this.product?.labels?.[0]?.split(".").reverse()[0];
    if(type == 'light') type = 'LIGHT'
    else if(type == 'std') type = 'STANDARD'
    else if(type == 'int') type = 'INTENSIVE'
    return `COL.COURSES.PRODUCTS.PLANS.${type}.TITLE`;
  }

  getPlanSubtitleKey() {
    let type = this.product?.labels?.[0]?.split(".").reverse()[0];
    const isSpanish = this.product?.product?.code?.includes('lessons.sp');
    const isKids = this.product?.product?.code?.includes('en.ch');
    if (type === 'light') {
      return isKids
        ? 'COL.COURSES.PRODUCTS.PLANS.ENCFK.LIGHT_SUBTITLE'
        : 'COL.COURSES.PRODUCTS.PLANS.LIGHT.SUBTITLE';
    }
    if (type === 'std') {
      return isKids
        ? 'COL.COURSES.PRODUCTS.PLANS.ENCFK.STANDARD_SUBTITLE'
        : 'COL.COURSES.PRODUCTS.PLANS.STANDARD.SUBTITLE';
    }
    if (type === 'int') {
      if (isKids) return 'COL.COURSES.PRODUCTS.PLANS.ENCFK.INTENSIVE_SUBTITLE';
      return isSpanish
        ? 'COL.COURSES.PRODUCTS.PLANS.SP_INTENSIVE_SUBTITLE'
        : 'COL.COURSES.PRODUCTS.PLANS.INTENSIVE.SUBTITLE';
    }
    return null;
  }

  getEnbusType() {
    let type = this.product?.labels?.[0]?.split(".").reverse()[0]?.toUpperCase();
    return `COL.COURSES.PRODUCTS.PLANS.ENBUS_TYPE.${type}`;
  }
  getWeeksAmount() {
    return +this.product?.name?.split(" ")[2];
  }

  getWeeksAmountTranslation() {
    let amount = this.getWeeksAmount();
    let translation = "COL.COURSES.PRODUCTS.PLANS.WEEKS_PLURAL."
    if(amount === 1) translation += 'ONE'
    else if(amount === 12 || amount === 72) translation += 'MANY'
    else translation += 'OTHER'
    return translation
  }

  getLessonsAmount() {
    return +this.product?.description?.split(" ")[0];
  }

  getLessonsAmountTranslation() {
    let amount = this.getLessonsAmount();
    let translation = "COL.COURSES.PRODUCTS.PLANS.LESSONS_PLURAL."
    if(amount === 1) translation += 'ONE'
    else if(amount === 72) translation += 'MANY'
    else translation += 'OTHER'
    return translation
  }
  getCreditsAmount() {
    return this.product?.name?.split(" ")[0];
  }
  getCourseName() {
    let name: string
    if (this.product?.product?.code?.includes("en.bs")) name = "ENBUS";
    else if (this.product?.product?.code?.includes("en.ch")) name = "ENCFK";
    else if (this.product?.product?.code?.includes("sp")) name = "SP";
    else name = "EN";
    return `COL.COURSES.${name}`
  }
}
